import {Pipe, PipeTransform} from '@angular/core';
import {CommonDataService} from '../common/common-data.service';
import {OtpService} from './otp.service';
import {OtpRecipient} from './otp';

@Pipe({
  name: 'parseOtpErrorMessage',
})
export class ParseOtpErrorMessagePipe implements PipeTransform {

  constructor(private commonDataService: CommonDataService, private otpService: OtpService) {
  }

  transform(errorMessage: string) {
    return errorMessage.replace(
      '{supportNumber}',
      this.commonDataService.siteDetails.supportNumber
    ).replace(
      '{minutesToUnlock}',
      ParseOtpErrorMessagePipe.plural('minute', this.otpService.minutesToUnlock)
    ).replace(
      '{remainingAttempts}',
      ParseOtpErrorMessagePipe.plural('attempt', this.otpService.remainingAttempts)
    );
  }

  private static plural(word: string, count: number = 0) {
    let s = ['s', ''][Number(count == 1)];
    return count + ' ' + word + s;
  }
}

@Pipe({
  name: 'otpRecipientDisplay',
})
export class OtpRecipientDisplayPipe implements PipeTransform {
  transform(otpRecipient: OtpRecipient) {
    if (otpRecipient.name.length) {
      return `${otpRecipient.mobilePhone} (${otpRecipient.name})`;
    }
    return otpRecipient.mobilePhone;
  }
}
